import { Pipe, PipeTransform } from '@angular/core';
import { Tags } from 'src/app/_global/tags';

@Pipe({
  name: 'productTag'
})
export class ProductTagPipe implements PipeTransform {
  constructor(
    public tags: Tags,
  ) { }

  transform(tagId: number, property: 'name' | 'color'): string {
    const tag = this.tags.getAll().find((t) => t.tagId === tagId);
    if (property === 'color') {
      if (tag) return tag.color;
    } else {
      switch (tagId) {
        case -1:
          return "Active";
        case 0:
          return "Inactive";
        case -3:
          return "Product Active";
        case -4:
          return "Product Inactive";
        default:
          if (tag) return tag.name;
      }
    }
  }

}
